<mat-nav-list class="nav">
  <a mat-list-item class="menu-item" [routerLink]="routingService.lpHoldingsPage" routerLinkActive="active" #portfolioActive="routerLinkActive">
    <div class="list-item-content">
      <button *ngIf="!isViewingAsInvestor && (numberOfPortfolios$ | async) > 0" class="notification-container" mat-mini-fab>
        <span class="notification-value">{{numberOfPortfolios$ | async}}</span>
      </button>
      <mat-icon class="notranslate material-icons-outlined">home_work</mat-icon>
      PORTFOLIO
    </div>
  </a>

  <a *ngIf="!isViewingAsInvestor" mat-list-item class="menu-item" [routerLink]="routingService.lpBankAccounts" routerLinkActive="active" #portfolioActive="routerLinkActive">
    <div class="list-item-content">
      <mat-icon class="notranslate material-icons-outlined">account_balance</mat-icon>
      BANK ACCOUNTS
    </div>
  </a>

  <a *ngIf="!isViewingAsInvestor" mat-list-item class="menu-item" [routerLink]="routingService.lpDocuments" routerLinkActive="active" #portfolioActive="routerLinkActive">
    <div class="list-item-content">
      <mat-icon class="notranslate material-icons-outlined">description</mat-icon>
      DOCUMENTS
    </div>
  </a>

  <a *ngIf="!isViewingAsInvestor" mat-list-item class="menu-item" [routerLink]="routingService.myAccountPageLp" routerLinkActive="active" #accountActive="routerLinkActive">
    <div class="list-item-content">
      <mat-icon class="notranslate">account_circle</mat-icon>
      PROFILE
    </div>
  </a>
</mat-nav-list>
